// extracted by mini-css-extract-plugin
export var modal = "_5w-0";